export default __webpack_public_path__ + "static/media/production-about-leather-coat.6fd45b13.png";